import { useEffect } from "react";
import { useResponsiveMobile } from "../../hooks/useResponsiveMobile";
import { Section1 } from "./component/Section1";
import { Section2 } from "./component/Section2";
import { Section3 } from "./component/Section3";
import { Section4 } from "./component/Section4";
import { setDescription } from "../../seo/seo";
import Banner from "../../component/Banner";

const ServiceCase = () => {
  const isMobile = useResponsiveMobile(900);
  useEffect(() => {
    document.title = "품 : Poom | 파트너 성공 사례";
    setDescription(
      `"운영이 단순해지고 파트너 관계가 달라졌어요." - 다양한 업종의 파트너사들이 품(POOM)과 함께 만들어가는 성공 스토리를 확인해 보세요.`,
    );
  }, []);
  return (
    <div className="w-full flex flex-col gap-[80px] md:gap-[160px] pb-[80px] md:pb-0">
      {isMobile ? (
        <>
          <img
            src={"/assets/images/case/bg_mobile_right.png"}
            alt="right_bg"
            className={`w-auto max-h-[874px] absolute top-[0px] right-0`}
            style={{ zIndex: -99 }}
          />

          <img
            src={"/assets/images/case/bg_mobile_left.png"}
            alt="left_bg"
            className={`w-auto max-h-[2040px] absolute top-[0px] left-0`}
            style={{ zIndex: -99 }}
          />
        </>
      ) : (
        <>
          <img
            src={"/assets/images/case/bg_right.png"}
            alt="right_bg"
            className={`w-auto max-h-[1750px] absolute top-[150px] right-0`}
            style={{ zIndex: -99 }}
          />

          <img
            src={"/assets/images/case/bg_left.png"}
            alt="left_bg"
            className={`w-auto max-h-[2070px] absolute top-[850px] left-0`}
            style={{ zIndex: -99 }}
          />
        </>
      )}
      {/* 상단 배너 */}
      <section className="w-full flex flex-col pt-6 md:pt-3 justify-center items-center px-6 pb-[40px] md:pb-0">
        <Banner
          pcImage="/assets/images/case/bg.webp"
          mobileImage="/assets/images/case/bg_mobile.webp"
        >
          <span className="text-black font-bold text-[20px] md:text-display3 text-center">
            {/* 모바일 */}
            <span className="md:hidden">
              정산·결제·영업대행 관리까지 <br />
              통합 솔루션으로 <br />
              업무 효율과 투명성을 높인 <br />
              실제 사례를 소개합니다.
            </span>

            {/* PC */}
            <span className="hidden md:inline">
              정산·결제·영업대행 관리까지 통합 솔루션으로
              <br />
              업무 효율과 투명성을 높인 실제 사례를 소개합니다.
            </span>
          </span>
        </Banner>
      </section>

      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
    </div>
  );
};

export default ServiceCase;
